
function gyb_mini_cart_contents() {

  var ajax_bag = $('.mini-cart-inner');

  jQuery.getJSON('/cart.js', function(cart) {

    // now have access to Shopify cart object
    // console.log('There are now ' + cart.item_count + ' items in the cart.');

    var freeshipping = '';
    var cart_total = cart.total_price;
    var cart_item_count = cart.item_count;
    var bag_total = formatMoney(cart_total);
    var product_item_loyalty_total = cart_total.toString().slice(0, -2);

    // If total less than R500
    if (cart_total < 50000) {
      freeshipping = 'Spend R500 and get FREE shipping!*';
    } else {
      freeshipping = 'Congratulations! You’ve qualified for FREE shipping!*';
    }

    $('#mini_cart_free_shipping').text(freeshipping);

    // Clear Cart Items
    ajax_bag.empty();

    // console.log(cart.items);

    // Check if we have any items in our mini cart
    if (cart.items.length === 0) {
      // console.log('Mini Cart Empty');

      cart_empty ='<div class="mini-cart-empty">';
      cart_empty +='<p><b>Your Shopping Bag is Empty!</b></p>';
      cart_empty +='<p>If you have saved items in your bag using account, please sign in to view them</p>';
      cart_empty +='</div>';

      $('#mini_cart_footer').hide();
      ajax_bag.append(cart_empty);

    } else {

      // Build Cart Items
      $.each(cart.items, function(i, item) {

        var product_title = item.title;

        // GYB - Clean Vend Product Title
        var product_title_parts = item.title.split("|");

        var product_image = Shopify.Image.getSizedImageUrl(item.image, 'medium');
        var product_vendor = item.vendor;
        var product_handle = item.handle;
        var product_key = item.key;
        var product_number = item.handle.split("-");
        var product_qty = item.quantity;
        var product_price = formatMoney(item.price);
        var product_item_total = formatMoney(item.quantity * item.price);


        cart_item ='<div class="dd-row">';

        cart_item +=' <div class="cart-item-img">';
        cart_item +='   <a class="cart-item-product-link" href="/products/'+ product_handle +'">';
        cart_item +='     <img src="' + product_image + '" alt="' + product_title + '">';
        cart_item +='   </a>';
        cart_item +=' </div>';
        cart_item +=' <div class="cart-item-content">';
        cart_item +='   <div class="cart-item-details">';
        cart_item +='     <div class="cart-item-row">';
        cart_item +='       <div class="cart-item-col col-left">';
        cart_item +='         <span class="cart-item-product-code">' + product_number[product_number.length-1] + '</span>';
        // GYB - Clean Vend Product Title
        cart_item +='         <a class="cart-item-title-link" href="/products/'+ product_handle +'">' + product_title_parts[product_title_parts.length-1] + '</a>';   
cart_item +='         <div class="limoniapps-discountninja-cart-item-product-comment" data-limoniapps-discountninja-cart-key="'+ product_key +'"></div>';
cart_item +='       </div>';
   
        cart_item +='       <div class="cart-item-col">';
        cart_item +='         <div class="cart-item-price limoniapps-discountninja-cart-item-product-price" data-limoniapps-discountninja-cart-key="'+ product_key +'">'+ product_price +'</div>';
        cart_item +='       </div>';
        cart_item +='     </div>';
        cart_item +='     <div class="cart-item-row">';
        cart_item +='       <div class="cart-item-col col-left">';
        cart_item +='         <div class="cart-item-qty">Qty '+ product_qty +'</div>';
        cart_item +='       </div>';
        cart_item +='       <div class="cart-item-col">';
        cart_item +='         <div class="cart-item-total limoniapps-discountninja-cart-item-line-price" data-limoniapps-discountninja-cart-key="'+ product_key +'">'+ product_item_total +'</div>';
        cart_item +='       </div>';
        cart_item +='     </div>';
        cart_item +='   </div>';
        cart_item +=' </div>';

        cart_item +='</div>';
        ajax_bag.append(cart_item);


      });

      $('#mini_cart_footer').show();
      $('#mini_cart_order_total').text(bag_total);
      $('#mini_cart_loyalty_total').text(product_item_loyalty_total);

    }


  });
}

gyb_mini_cart_contents();




/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

const moneyFormat = 'R{{amount}}';

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}









// ---------------------------------------------------------------------------
// Image.switchImage
// helps to switch variant images on variant selection
// ---------------------------------------------------------------------------
Shopify.Image = {

  preload: function (images, size) {
    for (var i=0; i < images.length; i++) {
      var image = images[i];

      this.loadImage(this.getSizedImageUrl(image, size));
    }
  },

  loadImage: function (path) {
    new Image().src = path;
  },

  switchImage: function (image, element, callback) {
    if (!image || !element) {
      return;
    }

    var size = this.imageSize(element.src)
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element);
    } else {
      element.src = imageUrl;
    }
  },

  imageSize: function (src) {
    var match = src.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);

    if (match != null) {
      return match[1];
    } else {
      return null;
    }
  },

  getSizedImageUrl: function (src, size) {
    if (size == null) {
      return src;
    }

    if (size == 'master') {
      return this.removeProtocol(src);
    }

    var match  = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    } else {
      return null;
    }
  },

  removeProtocol: function (path) {
    return path.replace(/http(s)?:/, "");
  }
};







// Newsletter
$(".gyb-newsletter").on("click", function() {
  $("#gyb_newsletter").addClass("active");
  // $("body").addClass("modal-active");
});


$('.modal-container').click(function(e){
  e.stopPropagation();
});

$(".modal-close, .modal-mask").unbind('click');
$(".modal-close, .modal-mask").on("click", function() {
  $(".modal-mask").removeClass("active");
});

$(document).keyup(function(e) {
  if (e.keyCode == 27) {
    $(".modal-mask").removeClass("active");
  }
});













// MENU - DROPDOWNS
// drop down menu script
$( ".gyb-dropdown-menu" ).on( "click", "a", function() {
	$('.gyb-dropdown-menu').removeClass('active');
	$(this).parent().toggleClass('active');
});

$(document).on("click", function(event){
	var $trigger = $(".gyb-dropdown-menu");

  if($trigger !== event.target && !$trigger.has(event.target).length){
		$(".gyb-dropdown-menu").removeClass("active");
	}
});



// Mobile Search Btn
$('#subscribe_to_email').on('click', function(event) {
  setTimeout(function(){
    $(".newsletter__input").filter(':visible').focus();
  }, 300);
});


// Mobile Search Btn
$('#mobile_nav_search').on('click', function(event) {
  $( '.mobile-search-dropdown' ).toggleClass( "show-mobile-search" );
});


// Accordion Btn
$('#section-accordion_btn').on('click', function(event) {
  $( '.section-accordion-content' ).toggleClass( "open" );
  $( '.section-accordion-title' ).toggleClass( "open" );
});



// Open External Links in a new Window
//$('a[href^="http"]').not('a[href^="'+$(location).attr('hostname')+'"]').attr('target', '_blank');


// Smooth Scroll - click anchor links
$('a[href^="#"]').on('click', function(event) {
    var target = $(this.getAttribute('href'));
    if( target.length ) {
        event.preventDefault();
        $('html, body').stop().animate({
            scrollTop: target.offset().top
        }, 1000);
    }
});


// Logo Wave Icon
$('.search-header__input').on("click", function() {
  $('.waving').removeClass('animate');
  void this.clientWidth; // read any dom property, doesn't matter which
  $('.waving').addClass('animate');
});



// Tabs
$('.nav-tabs .tabs li').click(function() {
	var tab_id = $(this).attr('data-tab');

	$('.nav-tabs .tabs li').removeClass('current');
	$('.tab-content').removeClass('current');

	$(this).addClass('current');
	$("#"+tab_id).addClass('current');
})




// Wish List counter
function renderWishlistCounter() {
  var element = document.querySelector('#wishlist_count');
  window._swat.renderWishlistCount(element, function(cnt, elem) {
    // console.log("debug – renderWishlistCount", cnt, elem); // Can be removed after verification
  });
}

if(!window._swat) {
  if(!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(renderWishlistCounter);
} else {
  renderWishlistCounter();
}


var checkExist = setInterval(function() {
   if ($('.swym-tooltip-text').length) {
      clearInterval(checkExist);

      $('.swym-btn-container .btn').removeClass('swym-button swym-add-to-wishlist');
      $('.swym-btn-container .swym-wishlist-cta').text('Add to Wish List');

   }
}, 100); // check every 100ms




// ----- NEW SLIDESHOW TEST
// $('.slideshow-featured-image').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: true,
//   dots: false,
//   draggable: true,
//   asNavFor: '.slideshow-thumbnails',
// });
//
//
// $('.slideshow-thumbnails').slick({
//   dots: false,
//   arrows: true,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 12,
//   slidesToScroll: 5,
//   focusOnSelect: true,
//   asNavFor: '.slideshow-featured-image',
// });
//
// $('.slideshow-item').zoom();
//



$('.gyb-collection-theme-slide').slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});



var checkExist = setInterval(function() {
   if ($('#gf-tree').length) {
      console.log("Exists!");


      $('.gf-option-box li:contains("Sale")').each(function(){
        $(this).addClass('filter-sale');
      });


      clearInterval(checkExist);
   }
}, 100); // check every 100ms
